import AdditionalServiceCategories from "@/views/premium-services/premium-service-categories/PremiumServiceCategories.vue";
import { ConciergeServicesListMixin } from "@/mixins/ConciergeServicesList.ts";
import { ServiceStatus } from "@/enums/ServiceStatus";
import { getStatusColor } from "@/utils/getStatusColor";
import { ConciergeServiceType } from "@/enums/ConciergeServiceType";
import moment from "moment";
import { localizedDate } from "@/utils/localizedDate";
import BookEventDlg from "../event-booking/BookEventDlg.vue";
import BookRequestDlg from "../request-booking/BookRequestDlg.vue";
import ProductOrderingDlg from "../product-ordering/ProductOrderingDlg.vue";

//TODO: divide this component into three separate ones, according to ConciergeServiceType enum

export default {
  name: "ConciergeBookingItems",
  components: {
    AdditionalServiceCategories,
    BookEventDlg,
    BookRequestDlg,
    ProductOrderingDlg
  },
  mixins: [ConciergeServicesListMixin],
  props: {
    isExpanded: {
      type: Boolean
    },
    itemType: {
      type: ConciergeServiceType
    },
    title: {
      type: String
    },
    items: {
      type: Array
    },
    selectedStatus: {
      type: String
    }
  },
  data() {
    return {
      isOpenBookDlg: false,
      isOpenRequestDlg: false,
      isOpenProductDlg: false,
      search: "",
      conciergeServiceType: ConciergeServiceType,
      selectedServicesStatus: "AllActive",
      jsonFields: {
        Status: "status",
        "Requester": "requesterName",
        Resident: "residentName",
        Name: "serviceName",
        Dimension: "category",
        Provider: "providerName",
        "Date Booked": "createdDateTime"
      },
      headers: [
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Status'],
          value: "status",
          sortable: false,
          show: true,
          width: this.isExpanded ? 170 : 80,
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Resident'],
          align: "start",
          value: "residentName",
          width: 170,
          show: true
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['BookingsAndOrders.Requester'],
          align: "start",
          value: "requesterName",
          width: 170,
          show: true
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Name'],
          align: "start",
          value: "serviceName",
          width: 170,
          show: true
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Dimension'],
          align: "start",
          value: "category",
          sortable: true,
          width: 170,
          show: true
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['BookingsAndOrders.EventDate'],
          align: "start",
          value: "start",
          sortable: true,
          width: 170,
          show: (this.itemType === ConciergeServiceType.ConciergeEvent),
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['ServiceList.Provider'],
          align: "start",
          value: "providerName",
          width: 170,
          show: true
        },
        {
          text: this.$t(`BookingsAndOrders.${this.itemType === ConciergeServiceType.ConciergeProduct ? 'DateOrdered' : 'DateBooked'}`),
          value: "createdDateTime",
          width: 170,
          show: true
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['ServiceList.RefNo'],
          align: "start",
          value: "id",
          width: 100,
        },
      ]
    }
  },
  computed: {
    serviceRequestsFiltered() {

      if (!this.items) return []

      let serviceRequests = this.serviceRequests


      if (this.selectedStatus) {
        this.selectedServicesStatus = this.selectedStatus;
      }

      if (this.selectedServicesStatus !== 'All' && this.selectedServicesStatus !== 'AllActive') {
        serviceRequests = serviceRequests.filter(x => x.status === this.selectedServicesStatus)
      }

      if(this.selectedServicesStatus === 'AllActive'){
        serviceRequests = serviceRequests.filter(x=>x.status === ServiceStatus.AwaitingApproval || x.status === ServiceStatus.Approved)
      }

      if (this.search) {
        serviceRequests = serviceRequests.filter(service => service.serviceName.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
      }

      const itemsIds = this.items.map(x => x.id)

      console.log('serviceRequestsFiltered')

      return serviceRequests.filter(x => itemsIds.includes(x.serviceId)).map((eventRequest) => {
        const service = this.items.find(x => x.id === eventRequest.serviceId)
        const event = {
          ...eventRequest,
          serviceName: eventRequest.serviceName || eventRequest.id,
          requesterName: eventRequest.bookByFamilyName || eventRequest.bookByResidentName || eventRequest.bookByStaffName,
          statusColor: getStatusColor(eventRequest.status),
          start: service?.start ? localizedDate(moment(service.start.seconds * 1000).toDate()) : 'N/A'
        }
        return event
      }).sort((a, b) => moment(b.createdDateTime).diff(moment(a.createdDateTime)));
    },
    serviceRequests() {
      console.log('serviceRequests')

      return this.$store.state.additionalServicesModule.serviceRequests
    },
  },
  created() {
    this.headers = this.headers.filter(x => x.show)
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded
      this.$emit('onExpandConciergeItems', this.isExpanded)
    },
    resetFilters() {
      this.selectedServicesStatus = "Awaiting Approval";
      this.search = ''
    },
    bookItem() {
      if (this.itemType === ConciergeServiceType.ConciergeEvent) {
        this.openBookDialog()
      }
      else if (this.itemType === ConciergeServiceType.ConciergeRequest) {
        this.openRequestDialog()
      }
      else if (this.itemType === ConciergeServiceType.ConciergeProduct) {
        this.openProductDialog()
      }
    },
    handleClickService(e){
      this.$router.push("bookings-and-orders/" + e.id );
    },
    openBookDialog() {
      this.isOpenBookDlg = true
    },
    openRequestDialog() {
      this.isOpenRequestDlg = true
    },
    openProductDialog() {
      this.isOpenProductDlg = true
    }
  },
}
